import styled from '@emotion/styled';
import type { FC } from 'react';
import { copyIntoClipBoard } from 'src/components/utils/copyIntoClipBoard';
import { IconCopy } from '../Icons';

interface Props {
  copyValue: string;
  title?: string;
  color?: string;
}

export const MiniCopyButton: FC<Props> = ({ copyValue, title, color = 'inherit' }) => {
  const handleCopyClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event.stopPropagation();
    copyIntoClipBoard(copyValue);
  };

  return (
    <Container
      onClick={(event) => handleCopyClick(event)}
      title={title}
      className="mini-copy-button"
      color={color}
    >
      <IconCopy />
    </Container>
  );
};

const Container = styled.div<{ color: string }>`
  cursor: pointer;
  z-index: 10;
  color: ${({ color }) => color};

  svg:hover {
    transform: scale(1.2);
  }
`;
